/* Sorting
 *
 * - Public API
 *   - order from public api documentation
 * - Internal API
 *   - order from internal api documentation
 * - Undocumented API
 *   - order alphabetically
 */

export enum NinchatErrorType {
    // Public API
    NinchatAccessAlreadySpentError = 'access_already_spent',
    NinchatAccessBlockedError = 'access_blocked',
    NinchatAccessDeniedError = 'access_denied',
    NinchatAccessExpiredError = 'access_expired',
    NinchatActionNotSupportedError = 'action_not_supported',
    NinchatAudienceNotFoundError = 'audience_not_found',
    NinchatChannelNotFoundError = 'channel_not_found',
    NinchatChannelQuotaExceededError = 'channel_quota_exceeded',
    NinchatConnectionSupersededError = 'connection_superseded',
    NinchatDeprecatedError = 'deprecated',
    NinchatFileNotFoundError = 'file_not_found',
    NinchatFileNotSupportedError = 'file_not_supported',
    NinchatIdentityAlreadyExistsError = 'identity_already_exists',
    NinchatIdentityNotFoundError = 'identity_not_found',
    NinchatInternalError = 'internal',
    NinchatMessageDroppedError = 'message_dropped',
    NinchatMessageHasTooManyPartsError = 'message_has_too_many_parts',
    NinchatMessageMalformedError = 'message_malformed',
    NinchatMessageNotSupportedError = 'message_not_supported',
    NinchatMessagePartTooLongError = 'message_part_too_long',
    NinchatMessageTooLongError = 'message_too_long',
    NinchatMessageTypeTooLongError = 'message_type_too_long',
    NinchatMessageTypesTooLongError = 'message_types_too_long',
    NinchatPayloadHasTooManyPartsError = 'payload_has_too_many_parts',
    NinchatPayloadPartTooLongError = 'payload_part_too_long',
    NinchatPermissionAlreadySpentError = 'permission_already_spent',
    NinchatPermissionDeniedError = 'permission_denied',
    NinchatPermissionExpiredError = 'permission_expired',
    NinchatQueueIsClosedError = 'queue_is_closed',
    NinchatQueueIsEmptyError = 'queue_is_empty',
    NinchatQueueIsFullError = 'queue_is_full',
    NinchatQueueIsSuspendedError = 'queue_is_suspended',
    NinchatQueueMemberQuotaExceededError = 'queue_member_quota_exceeded',
    NinchatQueueNotFoundError = 'queue_not_found',
    NinchatQueueQuotaExceededError = 'queue_quota_exceeded',
    NinchatRealmAlreadyExistsError = 'realm_already_exists',
    NinchatRealmNotFoundError = 'realm_not_found',
    NinchatRealmQuotaExceedError = 'realm_quota_exceeded',
    NinchatRequestMalformedError = 'request_malformed',
    NinchatSendRateLimitedError = 'send_rate_limited',
    NinchatSessionBufferOverflowError = 'session_buffer_overflow',
    NinchatSessionNotFoundError = 'session_not_found',
    NinchatTagNotFoundError = 'tag_not_found',
    NinchatUploadQuotaExceededError = 'upload_quota_exceeded',
    NinchatUserNotFoundError = 'user_not_found',
    // Internal API
    NinchatSsoNotAvailable = 'sso_not_available',
}

// vim:foldmethod=syntax
